import React, { useEffect } from 'react';
import { gsap } from 'gsap';

const Footer: React.FC = () => {
  useEffect(() => {
    gsap.fromTo('.footer', 
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }
    );
  }, []);

  return (
    <footer className="footer bg-text text-white">
      <div className="section-content py-16">
        <div className="grid-3 mb-12">
          {/* Company Info */}
              <div>
            <h3 className="heading-sm text-white mb-6">Maho Fine Foods</h3>
            <p className="text-body-sm text-white/80 mb-6">
              Connecting exceptional food suppliers with discerning culinary establishments. 
              We curate the finest ingredients for the wine and dine industry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-xs text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#home" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">Home</a></li>
              <li><a href="#about" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">About</a></li>
              <li><a href="#services" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">Services</a></li>
              <li><a href="#suppliers" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">Suppliers</a></li>
              <li><a href="#contact" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-xs text-white mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <p className="text-white/70 text-body-sm">Thames Rd 14, Maho</p>
              </div>
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:jay@mahowineanddine.com" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">
                  jay@mahowineanddine.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+17215503241" className="text-white/70 hover:text-primary transition-colors duration-300 text-body-sm">
                  +1 721 550 3241
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/70 text-body-xs">
              © 2025 Maho Fine Foods. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy" className="text-white/70 hover:text-primary text-body-xs transition-colors duration-300">Privacy Policy</a>
              <a href="/terms" className="text-white/70 hover:text-primary text-body-xs transition-colors duration-300">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
